import { createFileRoute } from '@tanstack/react-router';

type BulkEditSearch = {
  ids?: string;
  selection?: string;
  q?: string;
  page?: number;
  brand?: string;
  collection?: string;
  priceMin?: string;
  priceMax?: string;
};

export const Route = createFileRoute('/products/bulk-edit/')({
  validateSearch: (search: Record<string, unknown>): BulkEditSearch => ({
    ids: typeof search.ids === 'string' ? search.ids : undefined,
    selection: typeof search.selection === 'string' ? search.selection : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    brand: typeof search.brand === 'string' ? search.brand : undefined,
    collection: typeof search.collection === 'string' ? search.collection : undefined,
    priceMin: typeof search.priceMin === 'string' ? search.priceMin : undefined,
    priceMax: typeof search.priceMax === 'string' ? search.priceMax : undefined,
  }),
});
